import React, { Component } from "react";

export default class DisplayError extends Component {
  render() {
    return (
      <span>
        <p style={{ color: this.props.color }}>{this.props.errorText}</p>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/DisplayError/DisplayError.js